import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19d89e5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "carousel-container",
    ref: "carouselRef"
};
const _hoisted_2 = { class: "carousel__item" };
const _hoisted_3 = ["alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_galeria_item_youtube = _resolveComponent("galeria-item-youtube");
    const _component_slide = _resolveComponent("slide");
    const _component_pagination = _resolveComponent("pagination");
    const _component_carousel = _resolveComponent("carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_carousel, {
            autoplay: _ctx.autoplayTimeout,
            "pause-autoplay-on-hover": true,
            "wrap-around": true,
            onSlideStart: _ctx.onSlideStart
        }, {
            addons: _withCtx(() => [
                (_ctx.vitrines.length > 1)
                    ? (_openBlock(), _createBlock(_component_pagination, { key: 0 }))
                    : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vitrines, (vitrine, ix) => {
                    return (_openBlock(), _createBlock(_component_slide, { key: ix }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                (vitrine.tipo === 'imagem')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "item img",
                                        style: _normalizeStyle('background-image: url(' + vitrine.data_src + ');'),
                                        alt: 'Vitrine ' + (ix + 1)
                                    }, null, 12, _hoisted_3))
                                    : _createCommentVNode("", true),
                                (vitrine.tipo === 'youtube')
                                    ? (_openBlock(), _createBlock(_component_galeria_item_youtube, {
                                        key: 1,
                                        vitrine: vitrine
                                    }, null, 8, ["vitrine"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 2
                    }, 1024));
                }), 128))
            ]),
            _: 1
        }, 8, ["autoplay", "onSlideStart"])
    ], 512));
}
